import { DownloadHistory } from '@/types/GraphqlSchema';
import { formatDate } from '@/utils/helpers';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Box, ListItemIcon, ListItemText, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { styles as dataGenerationHistoryStyles } from './styles';
interface DataGenerationHistoryItemProps {
  download: DownloadHistory;
}

const getStatusIcon = (status: string) => {
  if (status === 'completed') return <CheckCircleIcon color="success" />;
  if (status === 'in_progress') return <CircularProgress size={20} color="warning" />;
  return <CircularProgress size={20} color="inherit" />;
};

export const DataGenerationHistoryItem = ({ download }: DataGenerationHistoryItemProps) => {
  return (
    <Box sx={dataGenerationHistoryStyles.drawerItem}>
      <ListItemIcon sx={dataGenerationHistoryStyles.listItemIcon}>
        {getStatusIcon(download.status)}
      </ListItemIcon>
      <ListItemText primary={download.filename} secondary={formatDate(download.requestedAt)} />
      {download.status === 'completed' && download.presignedUrl && (
        <Button
          sx={dataGenerationHistoryStyles.button}
          variant="contained"
          href={download.presignedUrl}
        >
          <GetAppIcon fontSize="small" color="primary" />
          <Box sx={dataGenerationHistoryStyles.label}>Download</Box>
        </Button>
      )}
      {download.status === 'in_progress' && (
        <Box display="flex" alignItems="center">
          <CircularProgress color="secondary" />
          <Typography variant="caption" color="textSecondary" sx={{ ml: 1 }}>
            Generating...
          </Typography>
        </Box>
      )}
    </Box>
  );
};
